/**
 * @typedef {import('./lib/index.js').Callback} Callback
 * @typedef {import('./lib/index.js').Middleware} Middleware
 * @typedef {import('./lib/index.js').Pipeline} Pipeline
 * @typedef {import('./lib/index.js').Run} Run
 * @typedef {import('./lib/index.js').Use} Use
 */

export {trough, wrap} from './lib/index.js'
